import type { PropsWithChildren } from 'react';
import React from 'react';

import { ExternalRedirect } from 'src/shared/components';
import { useDetectUserSessionQuery } from 'src/shared/graphql/generated';
import { baseUrlToRedirectUrl } from 'src/shared/helpers/url';
import { useLocation } from 'src/shared/hooks';

type RedirectWithSessionProps = PropsWithChildren<{}>;

const RedirectWithSession = ({ children }: RedirectWithSessionProps) => {
  const { data } = useDetectUserSessionQuery();
  const { href } = useLocation();

  return data ? (
    <ExternalRedirect url={baseUrlToRedirectUrl(href)} />
  ) : (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>{children}</>
  );
};

export { RedirectWithSession };
